import React from "react";

const OverlayContainerWithMaterialUi = ({ open, setClose, children }) => {
  if (!open) return null;

  return (
    <div className="overlay-modal-overlay">
      <div className="overlay-modal-container">
        {setClose ? (
          <button className="overlay-modal-close-button" onClick={setClose}>
            &times;
          </button>
        ) : null}

        <div className="overlay-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default OverlayContainerWithMaterialUi;
